import { ColumnProps } from 'antd/lib/table';
import { Key } from 'react';
import { ProfiBazaColumnProps } from './GridHelper';
import { GridSettingsDto } from 'services/src/models';

export default class ColumnHelper {
    public static ensureRequiredColumns(keys: string[], columns: ProfiBazaColumnProps<any>[]): string[] {
        const requiredKeys = columns.filter(column => column.alwaysVisible).map(column => column.key!.toString());
        const lastKeys = columns.filter(column => column.alwaysLast).map(column => column.key!.toString());
        const allKeys = Array.from(new Set([...keys, ...requiredKeys]));
        return [...allKeys.filter(key => !lastKeys.includes(key)), ...allKeys.filter(key => lastKeys.includes(key))];
    }

    public static findColumnByKey<T>(
        columns: ProfiBazaColumnProps<T>[],
        key: Key
    ): ProfiBazaColumnProps<T> | undefined {
        for (let column of columns) {
            if (column.key === key) return column;

            if (column.children !== undefined) {
                let foundInChildren = this.findColumnByKey(
                    column.children,
                    key
                );

                //todo
                // if (foundInChildren !== undefined) return foundInChildren;
            }
        }

        return undefined;
    }

    public static getFlattenColumnKeys(columns: ColumnProps<any>[]): string[] {
        let visibleColumnsKeys: string[] = [];
        if (!columns) return visibleColumnsKeys;

        visibleColumnsKeys = columns
            .filter(column => column.key !== undefined && column.key !== 'actions' && column.key !== 'preview')
            .map(column => column.key!.toString());

        return visibleColumnsKeys;
        
    }

    public static getFlattenKeys(columns: ColumnProps<any>[]): string[] {
        let visibleColumnsKeys: string[] = [];

        if (columns) {
            columns.forEach((column) => {
                if (column.key != undefined) {
                    visibleColumnsKeys.push(column.key.toString());
                }
            });
        }
        return visibleColumnsKeys;
    }

    public static getVisibleColumnsKeys(
        gridSettings: GridSettingsDto | undefined,
        allColumns: ColumnProps<any>[]
    ): string[] {
        if (!gridSettings) return this.getFlattenKeys(allColumns);

        let filteredColumns = this.getVisibleColumns(gridSettings, allColumns);
        let visibleColumnsKeys: string[] = this.getFlattenKeys(filteredColumns);

        return visibleColumnsKeys;
    }

    public static getVisibleColumns(
        gridSettings: GridSettingsDto | undefined,
        allColumns: ProfiBazaColumnProps<any>[]
    ): ProfiBazaColumnProps<any>[] {
        if (!gridSettings) return [...allColumns].sort((a, b) => Number(!!a.alwaysLast) - Number(!!b.alwaysLast));

        let visibleColumns: ProfiBazaColumnProps<any>[] = [];
        const visibleColumnKeys = gridSettings.visibleColumnKeys;

        allColumns.forEach((column) => {
            if (
                column.key === 'actions' ||
                column.alwaysVisible ||
                visibleColumnKeys!.includes(column.key!.toString())
            ) {
                visibleColumns.push(column);
            }
        });

        if (visibleColumnKeys) {
            visibleColumns.sort(function (a, b) {
                const lastOrder = Number(!!a.alwaysLast) - Number(!!b.alwaysLast);
                if (lastOrder) return lastOrder;
                return (
                    visibleColumnKeys.indexOf(a.key!.toString()) -
                    visibleColumnKeys.indexOf(b.key!.toString())
                );
            });
        }

        return visibleColumns;
    }
}
